// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3h6RM","sendOtp":"AuthorizeToLogin_sendOtp__2KBy-"};